import type { GroupType, LabelMapper } from 'types';
import { groupsTexts } from 'consts/text';

export const groupTypeLabels: LabelMapper<GroupType> = {
    JOURNAL_GROUP: groupsTexts.type.group,
    JOURNAL_SPECIAL: groupsTexts.type.special,
};
